import { useEffect, useState } from 'react'

// Load an image and downsample it to W×H, returning an array of [r,g,b] per pixel.
// Used by the pixel-grid, tensor, segmentation and patch scenes.
export function useImagePixels(src, W, H) {
  const [pixels, setPixels] = useState(null)
  useEffect(() => {
    let cancelled = false
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      if (cancelled) return
      const c = document.createElement('canvas')
      c.width = W; c.height = H
      const ctx = c.getContext('2d', { willReadFrequently: true })
      ctx.drawImage(img, 0, 0, W, H)
      const d = ctx.getImageData(0, 0, W, H).data
      const out = []
      for (let i = 0; i < W * H; i++) out.push([d[i * 4], d[i * 4 + 1], d[i * 4 + 2]])
      setPixels(out)
    }
    img.src = src
    return () => { cancelled = true }
  }, [src, W, H])
  return pixels
}
